import {IdDocumentType} from '../proposal';
import {Dropdown} from './dropdown';

const ID_DOCUMENT_TYPE_OPTIONS_FR: Dropdown<IdDocumentType>[] = [
  {name: 'Permis de conduire', value: IdDocumentType.DRIVER_LICENSE},
  {name: 'Passeport', value: IdDocumentType.PASSPORT},
  {name: "Carte d'assurance maladie", value: IdDocumentType.HEALTH_INSURANCE},
];

const ID_DOCUMENT_TYPE_OPTIONS_EN: Dropdown<IdDocumentType>[] = [
  {name: "Driver's license", value: IdDocumentType.DRIVER_LICENSE},
  {name: 'Passport', value: IdDocumentType.PASSPORT},
  {name: 'Health insurance card', value: IdDocumentType.HEALTH_INSURANCE},
];

export const ID_DOCUMENT_TYPE_OPTIONS = {
  en: ID_DOCUMENT_TYPE_OPTIONS_EN,
  fr: ID_DOCUMENT_TYPE_OPTIONS_FR,
};
